import { FC } from 'react'

type Props = {
  message: string
  actionLabel?: string
  onAction?: () => void
}

// Shown next to a wizard's Next button when validation failed on a step that is not currently visible
const StepErrorAlert: FC<Props> = ({ message, actionLabel, onAction }) => {
  if (!message) return null

  return (
    <div className='alert alert-danger d-flex flex-wrap align-items-center justify-content-between gap-3 mt-5 mb-5' role='alert'>
      <span className='fw-bold'>{message}</span>
      {onAction && actionLabel && (
        <button type='button' className='btn btn-sm btn-danger' onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </div>
  )
}

export default StepErrorAlert
